import { ArrowRight } from "lucide-react";

const CheckupFinalCta = () => {
  const scrollToForm = () => {
    document.getElementById("checkup-form")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-14 md:py-20 bg-hero-bg">
      <div className="max-w-3xl mx-auto section-padding text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-hero-foreground tracking-tight mb-4">
          If Your Practice Is Serious About Growth, Start with Clarity
        </h2>
        <p className="text-hero-foreground/50 max-w-xl mx-auto mb-8 leading-relaxed">
          The fastest way to waste money is to keep adding tactics without knowing where the system is failing. The New Patient Growth Checkup gives you a clearer picture of what to fix first.
        </p>
        <button
          onClick={scrollToForm}
          className="inline-flex items-center justify-center gap-2 bg-accent text-accent-foreground px-8 py-4 rounded-lg text-base font-semibold hover:bg-accent/90 transition-all active:scale-[0.97] shadow-lg shadow-accent/25"
        >
          Request My Growth Checkup
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
};

export default CheckupFinalCta;
